import axios from '@/libs/api.request'
export const GetDepartment = data => {
  return axios.request({
    url: '/company/department',
    params: data,
    method: 'get'
  })
}
export const SaveDepartment = data => {
  return axios.request({
    url: '/company/department',
    data,
    method: 'put'
  })
}
export const DelDepartment = data => {
  return axios.request({
    url: '/company/department/delete',
    data,
    method: 'put'
  })
}
export const SetDepartmentAdmin = data => {
  return axios.request({
    url: '/company/department/admin',
    data,
    method: 'put'
  })
}
